<tcm-main-search-layout
                        [useAdvancedSearch]="false"
                        [useExport]="false"
                        [useGlobalSearch]="false"
                        [isLoading]="isLoading">
    <ng-container title>
        {{titleKey | translate}} {{'Common.SearchColumnsAndDetailsFields.History' | translate}}
    </ng-container>
    <ng-container commands>
        <button class="btn btn-default"
                (click)="back()">{{'Common.SearchActionsAndDetailsActions.Cancel' | translate}}</button>
    </ng-container>
    <ng-container *ngIf="viewModel" results-area>
        <search-results [search]="searchInstance">
            <table class="search-table">
                <thead>
                    <tr>
                        <th>{{'Common.SearchColumnsAndDetailsFields.User' | translate}}</th>
                        <th>{{'Common.SearchColumnsAndDetailsFields.Date' | translate}}</th>
                        <th class="changes-title">{{'Common.SearchColumnsAndDetailsFields.Changes' | translate}}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let record of rows; let index=index; let odd=odd; let even=even;"
                        [ngClass]="{odd: odd, even:even}">
                        <td>{{record.modifiedByName}}</td>
                        <td>{{record.modifiedAt | wafDateTime}}</td>
                        <td>
                            <div class="changes-container">
                                <div class="old-value">{{record.previousValue}}</div>
                                <div class="separator">
                                    <div class="separator-icon" *ngIf="record.previousValue != null"></div>
                                </div>
                                <div class="current-value">{{record.value}}</div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <search-paging [search]="searchInstance"></search-paging>
        </search-results>
    </ng-container>
</tcm-main-search-layout>